import React, {

  useState,
  useEffect

} from "react";

import {

  DragDropContext,
  Droppable,
  Draggable

} from "react-beautiful-dnd";

import "./RouteBubbleBar.css";

export default function RouteBubbleBar({

  tokens = [],

  activeIndex = -1,

  onSelect,

  onChange,

  procedureConfig,

  updateArrivalProcedure,

  updateDepartureProcedure,

}) {

  // =====================================
  // ✈️ CENTRALIZED PROCEDURE CONFIG
  // =====================================

  const arrivalConfig =
    procedureConfig?.arrival || {};

  const departureConfig =
    procedureConfig?.departure || {};

  // =====================================
  // STATE
  // =====================================

  const [

    editingIndex,

    setEditingIndex

  ] = useState(-1);

  const [

    editValue,

    setEditValue

  ] = useState("");

  // =====================================
  // 🛬 STAR TOKEN DETECTION
  // =====================================

  const isStarToken = (token) => {

    if (!token)
      return false;

    return /^[A-Z]{5}\d[A-Z]?$/.test(token);
  };

  // =====================================
  // 🛫 SID TOKEN DETECTION
  // =====================================

  const isSidToken = (token) => {

    if (!token)
      return false;

    return /^[A-Z]{5}\d[A-Z]?$/.test(token);
  };

  // =====================================
  // ✏️ DOUBLE CLICK EDIT
  // =====================================

  const getTokenType = (token) => {

  if (!token)
    return "normal";

  // ✈️ AIRPORT
  if (/^K[A-Z]{3}$/.test(token)) {
    return "airport";
  }

  // 🛫 SID / STAR
  if (/^[A-Z]{5}\d[A-Z]?$/.test(token)) {
    return "procedure";
  }

  // 🛣️ AIRWAY
  if (/^[JQVTA]\d+$/.test(token)) {
    return "airway";
  }

  // 📍 FIX
  if (/^[A-Z]{3,5}$/.test(token)) {
    return "fix";
  }

  return "normal";
};

  const handleDoubleClick = (

    index

  ) => {

    setEditingIndex(index);

    setEditValue(tokens[index]);
  };

  // =====================================
  // ✏️ INPUT CHANGE
  // =====================================

  const handleEditChange = (

    e

  ) => setEditValue(e.target.value);

  // =====================================
  // ✏️ SUBMIT EDIT
  // =====================================

  const handleEditSubmit = () => {

    if (

      editingIndex >= 0 &&

      editValue.trim() !== ""

    ) {

      const updated = [...tokens];

      updated[editingIndex] =
        editValue.trim();

      onChange?.(updated);
    }

    setEditingIndex(-1);

    setEditValue("");
  };

  // =====================================
  // ⌨️ KEYBOARD
  // =====================================

  const handleKeyDown = (e) => {

    if (e.key === "Enter") {

      handleEditSubmit();

    } else if (

      e.key === "Escape"

    ) {

      setEditingIndex(-1);

      setEditValue("");
    }
  };

  // =====================================
  // ❌ DELETE TOKEN
  // =====================================

  const handleDelete = (

    index

  ) => {

    const updated = [...tokens];

    updated.splice(index, 1);

    onChange?.(updated);
  };

  // =====================================
  // ➕ INSERT TOKEN
  // =====================================

  const handleInsertAfter = (

    index

  ) => {

    const updated = [...tokens];

    updated.splice(

      index + 1,
      0,
      "NEWFIX"
    );

    onChange?.(updated);

    setEditingIndex(index + 1);

    setEditValue("");
  };

  // =====================================
  // 🔀 DRAG END
  // =====================================

  const handleDragEnd = (

    result

  ) => {

    if (!result.destination)
      return;

    const reordered = [...tokens];

    const [moved] =
      reordered.splice(

        result.source.index,
        1
      );

    reordered.splice(

      result.destination.index,
      0,
      moved
    );

    onChange?.(reordered);
  };

  // =====================================
  // 🧠 TOKEN CLICK HANDLER
  // =====================================

  const handleTokenClick = (

    idx,
    tok

  ) => {

    // =====================================
    // 🛬 STAR DETECTION
    // =====================================

    if (isStarToken(tok)) {

      updateArrivalProcedure?.({

        star: tok
      });

      console.log(
        "🛬 STAR TOKEN SELECTED:",
        tok
      );
    }

    // =====================================
    // 🛫 SID DETECTION
    // =====================================

    if (isSidToken(tok)) {

      updateDepartureProcedure?.({

        sid: tok
      });

      console.log(
        "🛫 SID TOKEN SELECTED:",
        tok
      );
    }

    onSelect?.(idx, tok);
  };

  // =====================================
  // RENDER
  // =====================================

  return (

    <DragDropContext
      onDragEnd={handleDragEnd}
    >

      <Droppable

        droppableId="route-bubbles"

        direction="horizontal"
      >

        {(provided) => (

          <div

            className="route-bubble-bar"

            ref={provided.innerRef}

            {...provided.droppableProps}
          >

            {tokens.map((tok, idx) => (

              <Draggable

                key={idx}

                draggableId={`route-token-${idx}`}

                index={idx}
              >

                {(provided) =>

                  editingIndex === idx ? (

                    <input

                      ref={provided.innerRef}

                      {...provided.draggableProps}

                      {...provided.dragHandleProps}

                      type="text"

                      className="chip-edit-input"

                      value={editValue}

                      onChange={handleEditChange}

                      onBlur={handleEditSubmit}

                      onKeyDown={handleKeyDown}

                      autoFocus
                    />

                  ) : (

                    <div

                      ref={provided.innerRef}

                      {...provided.draggableProps}

                      {...provided.dragHandleProps}

className={`chip

  chip-${getTokenType(tok)}

  ${idx === activeIndex
    ? "chip-active"
    : ""}
`}

                      onClick={() =>
                        handleTokenClick(
                          idx,
                          tok
                        )
                      }

                      onDoubleClick={() =>
                        handleDoubleClick(idx)
                      }

                      title={tok}
                    >

                      {tok}

                      {/* ❌ DELETE */}

                      <button

                        className="bubble-delete"

                        onClick={(e) => {

                          e.stopPropagation();

                          handleDelete(idx);
                        }}

                        title="Delete fix"
                      >
                        ×
                      </button>

                      {/* ➕ INSERT */}

                      <button

                        className="bubble-insert"

                        onClick={(e) => {

                          e.stopPropagation();

                          handleInsertAfter(idx);
                        }}

                        title="Insert new fix"
                      >
                        +
                      </button>

                    </div>
                  )
                }

              </Draggable>
            ))}

            {provided.placeholder}

          </div>
        )}

      </Droppable>

    </DragDropContext>
  );
}